import { Form, Input, Select, Switch } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utils/api/fetchApi';

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;

    const ref = useRef<any>(undefined);

    const [merchanData, setMerchanData] = useState<any>();

    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService, {
                apiId: 'merchant',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success === true) {
                    setMerchanData(res.data);
                }
            })
        };
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'brand',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '品牌'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Form.Item
                        label="id"
                        name="id"
                        tooltip='不输入id可生成随机id'>
                        <Input disabled={data.type === 'NEW' ? false : true} />
                    </Form.Item>

                    <Form.Item
                        label="品牌英文名"
                        name="brandEnglishName"
                        rules={[{ required: true, message: '请输入英文品牌名称!' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="品牌名"
                        name="brandName"
                        rules={[{ required: true, message: '请输入品牌名称!' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="商户"
                        name="merchantId">
                        <Select
                            showSearch
                            placeholder="商户"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(merchanData, {
                                itemName: 'merchantName',
                                includeNull: true
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="联系人"
                        name="contacts">
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="电话"
                        name="contactNumber">
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>

                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;